import type { IUpdateUserProps, UpdateUserDTO } from "@src/domain/dto/users";
import type { IUserRepository } from "@src/domain/repositories/user";

export class UpdateUserUseCase {
  private readonly userRepository: IUserRepository;

  constructor(userRepository: IUserRepository) {
    this.userRepository = userRepository;
  }

  async execute(params: UpdateUserDTO): Promise<IUpdateUserProps> {
    return this.userRepository.updateUser(params);
  }
}
